import React from 'react';
import { motion } from 'framer-motion';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
export function About() {
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} transition={{
    duration: 0.5
  }} className="min-h-screen bg-white" data-id="element-172">
      <Header data-id="element-173" />

      <main className="pt-32 pb-24" data-id="element-174">
        {/* Hero Section / Meet Treena */}
        <section className="max-w-7xl mx-auto px-6 mb-32" data-id="element-175">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 items-center" data-id="element-176">
            <div className="lg:col-span-5 order-2 lg:order-1" data-id="element-177">
              <span className="section-overline" data-id="element-178">The Founder</span>
              <h1 className="text-[#4A0E0E] mb-8" data-id="element-179">Meet Treena</h1>
              <div className="space-y-6 text-[#2C2C2C]/70" data-id="element-180">
                <p data-id="element-181">
                  With over two decades immersed in the world of fine wines,
                  Treena founded Cork Dorx with a singular vision: to peel back
                  the layers of pretension that often surround wine culture.
                </p>
                <p data-id="element-182">
                  Her journey began in the sun-drenched vineyards of the valley,
                  where she discovered that the most profound wine experiences
                  weren't found in exclusive cellars, but in the stories shared
                  over a perfectly paired glass.
                </p>
              </div>
            </div>
            <div className="lg:col-span-7 order-1 lg:order-2" data-id="element-183">
              <div className="aspect-[4/5] overflow-hidden rounded-2xl shadow-2xl" data-id="element-184">
                <img src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&q=80&w=1200" alt="Treena - Founder of Cork Dorx" className="w-full h-full object-cover" data-id="element-185" />
              </div>
            </div>
          </div>
        </section>

        {/* Why Cork Dorx */}
        <section className="bg-[#FDFCF0] py-32 px-6 mb-32" data-id="element-186">
          <div className="max-w-4xl mx-auto text-center" data-id="element-187">
            <h2 className="text-[#4A0E0E] mb-12" data-id="element-188">Why Cork Dorx Was Created</h2>
            <p className="text-xl md:text-2xl text-[#2C2C2C]/80 font-serif italic leading-relaxed" data-id="element-189">
              "I saw a gap between the world of elite wine collecting and the
              curious enthusiast. Cork Dorx was born to bridge that
              divide—creating a space where education meets luxury, and where
              every guest feels empowered to explore their own palate."
            </p>
          </div>
        </section>

        {/* Our Mission */}
        <section className="max-w-7xl mx-auto px-6 mb-32" data-id="element-190">
          <div className="bg-[#4A0E0E] text-white p-16 md:p-24 rounded-3xl relative overflow-hidden" data-id="element-191">
            <div className="absolute top-0 right-0 w-64 h-64 bg-[#D4AF37] opacity-10 rounded-full -mr-32 -mt-32" data-id="element-192" />
            <div className="relative z-10 max-w-3xl" data-id="element-193">
              <span className="section-overline" data-id="element-194">Our Mission</span>
              <h2 className="text-white mb-8" data-id="element-195">
                Creating approachable and culturally engaging wine experiences
                through education, storytelling, food, and community.
              </h2>
            </div>
          </div>
        </section>

        {/* Professional Background / Credentials */}
        <section className="max-w-7xl mx-auto px-6 mb-32" data-id="element-196">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-16" data-id="element-197">
            <div className="lg:col-span-4" data-id="element-198">
              <h2 className="text-4xl font-serif text-[#4A0E0E] mb-6" data-id="element-199">
                Professional Background
              </h2>
              <p className="text-[#2C2C2C]/60 font-light" data-id="element-200">
                A legacy of excellence in hospitality and viticulture, defined
                by a commitment to the highest standards of service.
              </p>
            </div>
            <div className="lg:col-span-8" data-id="element-201">
              <div className="space-y-12" data-id="element-202">
                {[{
                title: 'Wine Tasting & Curation',
                desc: 'Expertise in identifying terroir, vintage characteristics, and curating world-class collections for private cellars.'
              }, {
                title: 'Bespoke Hosting',
                desc: 'A decade of experience leading intimate tastings and large-scale hospitality events with a focus on personal connection.'
              }, {
                title: 'Event Coordination',
                desc: 'Seamless execution of corporate retreats, luxury wedgings, and high-profile industry showcases.'
              }, {
                title: 'Wine Education Specialties',
                desc: 'Specialized curriculum development for sensory analysis, regional deep-dives, and pairing fundamentals.'
              }, {
                title: 'Private Group Experiences',
                desc: 'Tailored programming for discerning groups, ensuring every guest leaves with a deeper appreciation for the vine.'
              }].map((item, idx) => <div key={idx} className="flex gap-8 group" data-id="element-203">
                    <div className="text-[#D4AF37] font-serif text-2xl opacity-30 group-hover:opacity-100 transition-opacity" data-id="element-204">
                      0{idx + 1}
                    </div>
                    <div data-id="element-205">
                      <h4 className="text-xl font-serif text-[#4A0E0E] mb-2" data-id="element-206">
                        {item.title}
                      </h4>
                      <p className="text-[#2C2C2C]/70 font-light leading-relaxed" data-id="element-207">
                        {item.desc}
                      </p>
                    </div>
                  </div>)}
              </div>
            </div>
          </div>
        </section>

        {/* Core Pillars */}
        <section className="max-w-7xl mx-auto px-6 mb-32" data-id="element-208">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-16" data-id="element-209">
            <div className="space-y-6" data-id="element-210">
              <div className="h-px w-12 bg-[#D4AF37]" data-id="element-211" />
              <h3 className="text-2xl font-serif text-[#4A0E0E]" data-id="element-212">
                Passion for Education
              </h3>
              <p className="text-[#2C2C2C]/70 leading-relaxed font-light" data-id="element-213">
                We believe that knowledge is the ultimate luxury. Our sessions
                are designed to deepen your understanding of viticulture,
                terroir, and the winemaking process without the jargon.
              </p>
            </div>
            <div className="space-y-6" data-id="element-214">
              <div className="h-px w-12 bg-[#D4AF37]" data-id="element-215" />
              <h3 className="text-2xl font-serif text-[#4A0E0E]" data-id="element-216">
                Approachable Experiences
              </h3>
              <p className="text-[#2C2C2C]/70 leading-relaxed font-light" data-id="element-217">
                Luxury shouldn't be intimidating. We curate warm, inviting
                atmospheres where questions are encouraged and the joy of
                discovery is the primary focus.
              </p>
            </div>
            <div className="space-y-6" data-id="element-218">
              <div className="h-px w-12 bg-[#D4AF37]" data-id="element-219" />
              <h3 className="text-2xl font-serif text-[#4A0E0E]" data-id="element-220">
                Culture & Storytelling
              </h3>
              <p className="text-[#2C2C2C]/70 leading-relaxed font-light" data-id="element-221">
                Every bottle has a story. We pair world-class hospitality with
                the rich narratives of the people and places behind the wine,
                creating a holistic cultural experience.
              </p>
            </div>
          </div>
        </section>

        {/* Future Vision */}
        <section className="bg-[#FDFCF0] py-32 px-6" data-id="element-222">
          <div className="max-w-7xl mx-auto" data-id="element-223">
            <div className="text-center mb-20" data-id="element-224">
              <span className="text-xs font-bold uppercase tracking-[0.3em] text-[#D4AF37] mb-4 block" data-id="element-225">
                The Horizon
              </span>
              <h2 className="text-4xl md:text-6xl font-serif text-[#4A0E0E]" data-id="element-226">
                Future Vision
              </h2>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12" data-id="element-227">
              {[{
              title: 'Culinary Partnerships',
              desc: 'Collaborating with world-renowned chefs to create immersive dining experiences.'
            }, {
              title: 'Corporate Experiences',
              desc: 'Expanding our bespoke team-building and leadership retreats for global organizations.'
            }, {
              title: 'Nonprofit Events',
              desc: 'Leveraging wine culture to support and amplify community-driven social impact.'
            }, {
              title: 'Community Engagement',
              desc: 'Fostering a local ecosystem of wine enthusiasts through workshops and social clubs.'
            }, {
              title: 'Winery Collaborations',
              desc: 'Partnering with boutique estates to highlight unique stories and rare vintages.'
            }, {
              title: 'Travel & Media Content',
              desc: 'Bringing the valley to the world through editorial storytelling and digital media.'
            }].map((item, idx) => <div key={idx} className="bg-white p-10 rounded-2xl shadow-sm hover:shadow-md transition-shadow" data-id="element-228">
                  <h4 className="text-xl font-serif text-[#4A0E0E] mb-4" data-id="element-229">
                    {item.title}
                  </h4>
                  <p className="text-[#2C2C2C]/60 font-light leading-relaxed text-sm" data-id="element-230">
                    {item.desc}
                  </p>
                </div>)}
            </div>
          </div>
        </section>

        {/* Final CTA */}
        <section className="mt-48 text-center px-6" data-id="element-231">
          <h2 className="text-3xl md:text-5xl font-serif text-[#4A0E0E] mb-12" data-id="element-232">
            Experience the Story Firsthand
          </h2>
          <button className="bg-[#4A0E0E] text-white px-12 py-5 rounded-full font-bold uppercase tracking-widest text-sm hover:bg-[#D4AF37] transition-all duration-500 shadow-xl" data-id="element-233">
            Book a Tasting with Us
          </button>
        </section>
      </main>

      <Footer data-id="element-234" />
    </motion.div>;
}